import React from "react";
import { Input, Form, Modal, Button } from "antd";
import { supportApi } from "../../api/loginStudentApi";

const { TextArea } = Input;

export default function ({
  showHelp,
  setShowHelp,
  userEmail,
  success,
  setSuccess,
  loader,
  LoadingOutlined,
  dispatchLogin,
  playerId,
  firstName,
  lastName,
}) {
  const handleHelpSubmit = (value) => {
    console.log(value);

    supportApi(value, dispatchLogin, playerId);
  };

  return (
    <>
      <Modal
        title="Help & Support"
        className="help-modal"
        visible={showHelp}
        onCancel={() => setShowHelp(false)}
        centered
        footer={null}
        className="sml-modal"
      >
        <Form
          onFinish={handleHelpSubmit}
          validateTrigger="onSubmit"
          initialValues={{
            email: userEmail ? userEmail : "",
            firstname: firstName ? firstName : "",
            lastname: lastName ? lastName : "",
          }}
        >
          <Form.Item
            name="firstname"
            rules={[
              {
                max: 32,
                message: "Only 32 letters allow to input",
              },
              {
                required: true,
                message: "Please input your First Name",
              },
              {
                pattern: /^([a-zA-Z]{2,})?$/,
                message: "Number or any special character not allowed",
              },
              {
                pattern: /^\S+$/,
                message: "space not allowed",
              },
            ]}
          >
            <Input placeholder="First Name" />
          </Form.Item>

          <Form.Item
            name="lastname"
            rules={[
              {
                max: 32,
                message: "Only 32 letters allow to input",
              },
              {
                required: true,
                message: "Please input your Last Name",
              },
              {
                pattern: /^([a-zA-Z]{2,})?$/,
                message: "Number or any special character not allowed",
              },
              {
                pattern: /^\S+$/,
                message: "space not allowed",
              },
            ]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              // {
              //   required: true,
              //   message: "Please input your Email address",
              // },
              {
                pattern: /^([a-zA-Z\d_.-]{2,})@([a-zA-Z\d-]{2,})\.([a-zA-Z]{2,})(\.[a-zA-Z]{2,})?$/,
                message: "Please input correct Email address",
              },
              {
                max: 64,
                message: "Only 64 letters allow to input",
              },
              {
                pattern: /^\S+$/,
                message: "space not allowed",
              },
            ]}
          >
            <Input
              placeholder="Email"
              //   defaultValue={userEmail ? userEmail : ""}
            />
          </Form.Item>
          <Form.Item
            name="message"
            rules={[
              { required: true, message: "Please input your Message or Query" },
              {
                max: 500,
                message: "Only 500 letters allow to input",
              },
            ]}
          >
            <TextArea
              rows="4"
              placeholder="Type your query or message"
              maxLength={500}
            />
          </Form.Item>
          <Button
            htmlType="submit"
            className="btn-center custom-btn"
            style={{ marginLeft: "auto", marginRight: "auto" }}
          >
            {loader ? <LoadingOutlined /> : "Send Mail"}
          </Button>
        </Form>
      </Modal>
      <Modal
        title="MAIL DELIVERED"
        visible={success}
        onCancel={() => setSuccess(false)}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{
          className: "custom-btn",
          style: { marginLeft: "auto", marginRight: "auto" },
        }}
        onOk={() => setSuccess(false)}
        centered
        className="sml-modal"
        bodyStyle={{ paddingBottom: "0" }}
      >
        <h2 style={{ textAlign: "center" }}>
          Your Request has been sent to support team. Our team will get back to
          you soon
        </h2>
      </Modal>
    </>
  );
}
